import { SimpleForm } from 'react-admin';
import { CreateStyled } from '@/styles/overrides';
import FormContent from './FormContent';
import { RequestOneOffCheckProps } from './types';

// Enter in a text field submits the form natively; saving goes through the Save button only.
const ignoreNativeSubmit = () => undefined;

const RequestOneOffCheck = ({ checks, onClose, onRecordChange, record, worker, ...props }: RequestOneOffCheckProps) => {
  return (
    <CreateStyled title="Add Custom Check" {...props}>
      <SimpleForm mode="onChange" onSubmit={ignoreNativeSubmit} reValidateMode="onChange" toolbar={false}>
        <FormContent
          checks={checks}
          onClose={onClose}
          onRecordChange={onRecordChange}
          record={record}
          worker={worker}
        />
      </SimpleForm>
    </CreateStyled>
  );
};

export default RequestOneOffCheck;
